/* tslint:disable */

declare var Object: any;
export interface StorageAttendanceInterface {
  "id"?: number;
}

export class StorageAttendance implements StorageAttendanceInterface {
  "id": number;
  constructor(data?: StorageAttendanceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StorageAttendance`.
   */
  public static getModelName() {
    return "StorageAttendance";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StorageAttendance for dynamic purposes.
  **/
  public static factory(data: StorageAttendanceInterface): StorageAttendance{
    return new StorageAttendance(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StorageAttendance',
      plural: 'StorageAttendances',
      path: 'StorageAttendances',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/StorageAttendance.ts